<template>
    <div class="wrapBox" style=" padding-left:4px;padding-right:4px;padding-top:8px;">
        <div class="myChartTitleWrap">
            <div class="myChartTitle">{{titleText}}</div>
        </div>
        <div id="myLastYearInTrade" :style="{width: '100%', height: '210px'}">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LastYearInOutTrade',
        props: ['mainPageData'],
        data() {
            return {
                msg: 'Welcome to Your Vue.js App',
                titleText: '近一年内进口贸易统计金额',
                textStyle: {
                    color: '#ccc',
                    fontStyle: 'normal',
                    fontWeight: 'bold',
                    fontFamily: 'sans-serif',
                    fontSize: 12
                },
                legendPadding: [65, 5, 15, 5]
            }
        },
        mounted() {
            this.drawLine();
        },
        methods: {
            getTradeData (data) {
                let yearList = [];
                let value1List = [];
                let value2List = [];
                let value3List = [];
                for(var i=0; i<data.length; i++) {
                    yearList.push(data[i].name);
                    value1List.push(data[i].value1);
                    value2List.push(data[i].value2);
                    value3List.push(data[i].value3);
                }
                return {
                    yearList: yearList,
                    value1List: value1List,
                    value2List: value2List,
                    value3List: value3List
                };
            },
            drawLine() {
                // 基于准备好的dom，初始化echarts实例
                let myLastYearInTrade = this.$echarts.init(document.getElementById('myLastYearInTrade'))
                myLastYearInTrade.setOption({
                    backgroundColor: "#21232c",
                    textStyle: {
                        color: '#5d6066'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    grid: {
                        left: '5%',
                        right: '5%',
                        bottom: '5%',
                        top: '15%',
                        containLabel: true
                    },
                    legend: {
                        data: ['进口额', '人民币同比', '人民币环比'],
                        padding: [8, 10, 15, 20],
                        textStyle:{
                            color:'#ccc',
                            fontSize:12
                            }
                        ,
                    },
                    xAxis: [{
                        type: 'category',
                        data: this.getTradeData(this.mainPageData.lastYearI).yearList,
                        axisLabel: {
                            show: true,
                            interval: '0',
                            rotate: 45,
                            textStyle: {
                                color: '#fff'
                            }
                        }
                    }],
                    yAxis: [{
                            type: 'value',
                            name: '进口额(亿)',
                            show: true,
                            axisLine: {
                                show: true
                            },
                            axisTick: {
                                show: true
                            },
                            splitLine: {
                                show: false
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: '#fff'
                                }
                            },
                        },
                        {
                            type: 'value',
                            name: '比率',
                            show: true,
                            axisLine: {
                                show: true
                            },
                            axisTick: {
                                show: true
                            },
                            splitLine: {
                                show: false
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: '#fff'
                                }
                            },
                        }
                    ],
                    series: [{
                            name: '进口额',
                            type: 'bar',
                            barWidth: 15,
                            itemStyle: {
                                normal: {
                                    color: '#16c3c3'
                                }
                            },
                            data: this.getTradeData(this.mainPageData.lastYearI).value1List
                        },
                        {
                            name: '人民币同比',
                            type: 'line',
                            yAxisIndex: 1,
                            symbol: 'none',
                            itemStyle: {
                                normal: {
                                    color: '#e0c902'
                                }
                            },
                            data: this.getTradeData(this.mainPageData.lastYearI).value3List
                        },
                        {
                            name: '人民币环比',
                            type: 'line',
                            yAxisIndex: 1,
                            symbol: 'none',
                            itemStyle: {
                                normal: {
                                    color: '#c83438'
                                }
                            },
                            data: this.getTradeData(this.mainPageData.lastYearI).value2List
                        }
                    ]
                });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/LastYearInTrade.vue